import { observer } from "mobx-react-lite";

import { ParameterValue } from "../../utils";

import { ParameterControlContent } from "./ParameterControlContent";
import { ParameterLabel } from "./ParameterLabel";

import { ParameterStore } from "@/components/ModelParameters/store/parameter-store";

interface BasicParameterProps {
  parameter: ParameterStore;
  labelClasses: string;
  shouldShowToggle?: boolean;
  disabledClass: string;
  isDisabled?: boolean;
  value?: ParameterValue;
  readOnly?: boolean;
  isPreview?: boolean;
  onUpdate?: () => void;
}

export const BasicParameter = observer(
  ({
    parameter,
    labelClasses,
    disabledClass,
    isDisabled,
    value,
    shouldShowToggle,
    readOnly,
    isPreview,
    onUpdate,
  }: BasicParameterProps) => (
    <div
      className={`flex ${
        readOnly ? "w-full flex-row items-center justify-between" : "w-full flex-col gap-2"
      }`}
    >
      <ParameterLabel
        id={parameter.paramId ?? ""}
        name={parameter.name ?? ""}
        labelClasses={labelClasses}
        disabledClass={disabledClass}
        isDisabled={isDisabled}
        readOnly={readOnly}
        isPreview={isPreview}
        shouldShowToggle={shouldShowToggle}
        onToggle={isEnabled => {
          parameter.updateIsEnabled(isEnabled);
          onUpdate?.();
        }}
      />
      <div
        className={`w-full ${readOnly ? "max-w-[229px]" : ""} ${isDisabled ? disabledClass : ""}`}
      >
        <ParameterControlContent
          onChange={val => {
            parameter.updateValue(val);
            onUpdate?.();
          }}
          value={value ?? parameter.value ?? parameter.default ?? null}
          parameter={parameter}
          isDisabled={isDisabled}
          readOnly={readOnly}
          isPreview={isPreview}
        />
      </div>
    </div>
  ),
);
